// src/components/Login.js
import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const baseURL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const res = await fetch(`${baseURL}/api-token-auth/`, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ username, password })
      });
      if (!res.ok) {
        throw new Error('Vale kasutaja või parool');
      }
      const { token } = await res.json();
      localStorage.setItem('apiToken', token);
      localStorage.setItem('username', username);
      onLogin(token);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-sm mx-auto mt-16 p-6 bg-white shadow rounded">
      <h2 className="text-xl mb-4">Logi sisse</h2>
      {error && <div className="mb-2 text-red-500">{error}</div>}
      <div className="mb-4">
        <label className="block mb-1">Kasutajanimi</label>
        <input
          className="w-full p-2 border rounded"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
        />
      </div>
      <div className="mb-4">
        <label className="block mb-1">Parool</label>
        <input
          type="password"
          className="w-full p-2 border rounded"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
      </div>
      <button
        type="submit"
        className="w-full py-2 bg-primary text-white rounded hover:bg-primary-hover"
      >
        Sisene
      </button>
    </form>
  );
}
